import { createApiClient } from 'Network/ApiClient';

export const ClaimValidationAxiosInstance = createApiClient('validate/');


